// extracted by mini-css-extract-plugin
export default {"moreMargin":"Mechanics_moreMargin__IbHrc","container":"Mechanics_container__X1pDc","boxWrapper":"Mechanics_boxWrapper__3PakP"};